module.exports = __webpack_public_path__ + "static/media/alert.aa1b27f0.svg";